<template>
<div sidebar="compact" bottomnav>
    <PendoTracker />
    <router-view />
</div>
</template>

<script>
// import JQuery from 'jquery'
import PendoTracker from '@/components/Pendo/PendoTracker.vue';
import * as Dropzone from "dropzone";    
export default {
  name: "App",
  components: {
    PendoTracker
  },

  mounted() {
    // window.$ = JQuery;
    window.Dropzone = Dropzone
    },  
    methods: {
    }
};
</script >

<style>
@import "./assets/css/styles.css";
@import "./assets/css/spritesmith-generated/sprite.css";
</style>
